import { apiGet, apiPost } from '../../../shared/api-client/index.js';

export interface PrivacyOperationResult {
  id: string;
  stateVersion: number;
}
export interface TelegramPrivacyExport {
  generatedAt: string;
  scopeType: 'self_private' | 'group' | 'connection' | 'workspace';
  records: unknown[];
}

export const requestOwnTelegramPrivacyOperation = async (
  kind: 'export' | 'delete',
): Promise<PrivacyOperationResult> => {
  const challenge = await apiPost<
    { challengeId: string; confirmationToken: string; expiresAt: string },
    { kind: 'export' | 'delete'; scopeType: 'self_private' }
  >('/integrations/telegram/privacy-challenges', { kind, scopeType: 'self_private' });
  return apiPost('/integrations/telegram/privacy-operations', {
    kind,
    scopeType: 'self_private',
    challengeId: challenge.challengeId,
    confirmationToken: challenge.confirmationToken,
  });
};

export interface PrivacyOperationStatus {
  id: string;
  status: 'queued' | 'claimed' | 'running' | 'completed' | 'failed';
  failureCode: string | null;
}
export const getTelegramPrivacyOperation = (operationId: string): Promise<PrivacyOperationStatus> =>
  apiGet(`/integrations/telegram/privacy-operations/${encodeURIComponent(operationId)}`);

export const getOwnTelegramPrivacyExport = (operationId: string): Promise<TelegramPrivacyExport> =>
  apiGet(`/integrations/telegram/privacy-operations/${encodeURIComponent(operationId)}/export`);

export async function waitForOwnTelegramPrivacyExport(
  operationId: string,
): Promise<TelegramPrivacyExport> {
  for (let attempt = 0; attempt < 60; attempt += 1) {
    const operation = await getTelegramPrivacyOperation(operationId);
    if (operation.status === 'completed') return getOwnTelegramPrivacyExport(operationId);
    if (operation.status === 'failed')
      throw new Error(operation.failureCode ?? 'privacy_operation_failed');
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
  throw new Error('privacy_operation_timeout');
}
